import React, { useState, Fragment, useEffect } from 'react';
import { useStyle } from './style';
import EirPaymentDebitInformation from './EirPaymentDebitInformation';
import EirTermsAndConditions from './EirTermsAndConditions';
import {
	Paper, Grid,
	Box, Button,
	Stepper, Step, StepLabel
} from '@material-ui/core';
import { makeStyles, withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { theme } from './theme';
import StepConnector from '@material-ui/core/StepConnector';
import { isMobileOnly } from "react-device-detect";
import axios from 'axios';
import { RealexHpp } from '../eir-webmail/rxp-js';
import Loading from '../shared/Loading';
import clsx from 'clsx';
import { Icon } from "@material-ui/core";
import { Modal, ModalBody } from 'reactstrap';
import EirButton from '../eir-button/EirButton';
import PubSub from 'pubsub-js';
import Constants from '../../Constants';
import { pushTransactionReadyEvent } from '../../utils/Analytics';

export default function EirPaymentDetailsContainer(props) {

	const classes = useStyle();
	const [debitTandCStatus, setDebitTandCStatus] = useState(false);
	const [eirTandCStatus, setEirTandCStatus] = useState(false);
	const [bankDetailsStatus, setBankDetailsStatus] = useState(false);
	const [debitTandCError, setDebitTandCError] = useState(false);
	const [eirTandCError, setEirTandCError] = useState(false);
	const [orderConfirm, setOrderConfirm] = useState(false);
	const customerCheckoutActiveStep = props.customerCheckoutActiveStep;
	const [confirmMsg, setConfirmMsg] = useState(false);
	const [loading, setLoading] = useState(false);
	const [showCardArea, setShowCardArea] = useState(false);
	const [retryPayment, setRetryPayment] = useState(false);
	const [retryMsg, setRetryMsg] = useState("");
	const [confirmOrderId, setConfirmOrderId] = useState(null);
	const [paymentSuccessError, setPaymentSuccessError] = useState(false);
	const [paymentSuccessErrorTitle, setPaymentSuccessErrorTitle] = useState("");
	const [paymentSuccessErrorText, setPaymentSuccessErrorText] = useState("");
	var polCounter = 0;
	const handleContinue = () => {
		/*================================*/
		if (debitTandCStatus && eirTandCStatus) {
			setOrderConfirm(true);
			setActiveStep(3);
			window.scrollTo(0, 0);
			setShowCardArea(true);
			let order = JSON.parse(localStorage.getItem("eir_be_data")).order;
			if (order.bundle.mobiles.length > 0) {
				getHppRequest();
			} else {
				completeOrderWithoutPayment();// added to test without payment
			}
		}
		else {
			((!debitTandCStatus) && setDebitTandCError(true));
			((!eirTandCStatus) && setEirTandCError(true));
		}
	}
	/*payments methods*/
	async function getHppRequest() {
		window.history.replaceState(null, '', "/checkout/payment-details");
		polCounter = 0;//set polling counter to 0 for every retry.
		setShowCardArea(true);
		setRetryPayment(false);
		setLoading(true);
		try {
			let orderId = JSON.parse(localStorage.getItem("eir_be_data")).order.id;
			let urlPath = '/store/api/checkout/get-hpprequest/' + orderId;
			let res = await axios({
				url: urlPath,
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
				}
			})
			if (res.status == 200) {
				if (res.data.data) {
					loadHpp(res.data);// to load iframe	
				} else {
					setRetryMsg(res.data.message.message);
					setShowCardArea(false);
					setRetryPayment(true);
				}
			} else {
				setDataLayer("Checkout - Error : We're sorry - there has been a system error", '/checkout/order-error')
				setRetryMsg("We're sorry - there has been a system error.");
				setShowCardArea(false);
				setRetryPayment(true);
			}
		}
		catch (err) {
			console.error(err);
			setDataLayer("Checkout - Error : We're sorry - there has been a system error", '/checkout/order-error')
			setRetryMsg("We're sorry - there has been a system error.");
			setShowCardArea(false);
			setRetryPayment(true);
		}
	}

	/***IFRAME payment start***/
	const loadHpp = (data) => {
		var targetIframe, frameLoad, appDomain;
		targetIframe = $('#targetIframe');
		frameLoad = $('.Iframe-Module');
		appDomain = window.location.href;
		$('.Iframe-Module').css({ display: 'none' });
		if (appDomain.indexOf('testwww') > 0 || appDomain.indexOf('localhost') > 0) {
			RealexHpp.setHppUrl('https://pay.sandbox.realexpayments.com/pay');
		} else {
			RealexHpp.setHppUrl('https://pay.elavonpaymentgateway.com/pay');
		}
		RealexHpp.embedded.init(
			"pay-button",
			"targetIframe",
			"localhost",
			data.data.hppRequest,
			validateHppResponse);

		targetIframe.on('load', function () {
			setLoading(false);
			frameLoad.css({ display: 'block' });
		});
	};
	const validateHppResponse = (response) => {
		//setLoading(true);
		if (response.error) {
			setDataLayer("Checkout - Error : We're sorry - there has been a system error", '/checkout/order-error')
			setRetryMsg("We're sorry - there has been a system error.");
			setShowCardArea(false);
			setRetryPayment(true);
		} else {
			postData(response);
		}
	};

	async function postData(hppRes) {
		try {
			setLoading(true);
			let orderId = JSON.parse(localStorage.getItem("eir_be_data")).order.id;
			let urlPath = '/store/api/checkout/process-hppresponse-complete-order';
			let res = await axios({
				method: 'POST',
				url: urlPath,
				data: {
					encoded: true,
					hppResponse: hppRes,
					orderId: orderId,
				},
				cache: false,
				dataType: 'JSON',
				processData: false,
				headers: {
					'Content-Type': 'application/json',
				}
			})
			if (res.status == 200) {
				pollingPostData();
			} else {
				//system error without retry
				setLoading(false);
				clearLocalStorage();
				setShowCardArea(false);
				setPaymentSuccessError(true);
				setDataLayer("Checkout - Error : We're sorry - there has been a system error", '/checkout/order-error')
				setPaymentSuccessErrorTitle("We're sorry - there has been a system error");
				setPaymentSuccessErrorText('Payment may have been taken from your card but the system has failed to complete your order. Please email eirbillpayonline@eir.ie with your details to complete your order or receive a refund.');
			}
		}
		catch (err) {
			console.error(err);
			setLoading(false);
			clearLocalStorage();
			setShowCardArea(false);
			setPaymentSuccessError(true);
			setDataLayer("Checkout - Error : We're sorry - there has been a system error", '/checkout/order-error')
			setPaymentSuccessErrorTitle("We're sorry - there has been a system error");
			setPaymentSuccessErrorText('Payment may have been taken from your card but the system has failed to complete your order. Please email eirbillpayonline@eir.ie with your details to complete your order or receive a refund.');
		}
	}

	async function pollingPostData() {
		try {
			polCounter++;
			let orderId = JSON.parse(localStorage.getItem("eir_be_data")).order.id;
			let endpoint = '/store/api/checkout/process-hppresponse-poll/' + orderId;
			let res = await axios({
				method: 'GET',
				url: endpoint,
				cache: false,
				dataType: 'JSON',
				processData: false,
				contentType: false,
				headers: {
					'Content-Type': 'application/json',
				}
			})
			if (res.status == 200) {
				if (res.data.completed) {
					if (res.data.success) {
						// backend operation successful
						if (res.data.paymentSuccess) {
							// payment successful
							if (res.data.orderComplete) {
								// order completed successfully								
								setLoading(false);
								finishOrder(res);
							} else {
								// problem completing order but payment successful
								setLoading(false);
								paySuccessError();
							}
						} else {
							// problem taking payment
							setDataLayer(res.data.message.message, '/checkout/payment-details')
							setLoading(false);
							setRetryMsg(res.data.message.message);
							setShowCardArea(false);
							setRetryPayment(true);
						}
					} else {
						// backend operation failure
						//system error without retry
						setDataLayer("Checkout - Error : We're sorry - there has been a system error", '/checkout/order-error')
						setLoading(false);
						clearLocalStorage();
						setShowCardArea(false);
						setPaymentSuccessError(true);
						setPaymentSuccessErrorTitle("We're sorry - there has been a system error");
						setPaymentSuccessErrorText('Payment may have been taken from your card but the system has failed to complete your order. Please email eirbillpayonline@eir.ie with your details to complete your order or receive a refund.');
					}
				} else {
					if (polCounter < 20) {
						setTimeout(pollingPostData, 5500);
					} else {
						setLoading(false);
						clearLocalStorage();
						setShowCardArea(false);
						setPaymentSuccessError(true);
						setDataLayer("Checkout - Error : We're sorry - there has been a system error", '/checkout/order-error')
						setPaymentSuccessErrorTitle("We're sorry - there has been a system error");
						setPaymentSuccessErrorText('Payment may have been taken from your card but the system has failed to complete your order. Please email eirbillpayonline@eir.ie with your details to complete your order or receive a refund.');
					}
				}
			} else {
				setLoading(false);
				setDataLayer("Checkout - Error : We're sorry - there has been a system error", '/checkout/order-error')
				setRetryMsg("We're sorry - there has been a system error.");
				setShowCardArea(false);
				setRetryPayment(true);
			}
		}
		catch (err) {
			setDataLayer("Checkout - Error : We're sorry - there has been a system error", '/checkout/order-error')
			setLoading(false);
			clearLocalStorage();
			setShowCardArea(false);
			setPaymentSuccessError(true);
			setPaymentSuccessErrorTitle("We're sorry - there has been a system error");
			setPaymentSuccessErrorText('Payment may have been taken from your card but the system has failed to complete your order. Please email eirbillpayonline@eir.ie with your details to complete your order or receive a refund.');
		}
	}
	const finishOrder = (res) => {
		// checkout.step4b.submit = false;
		// checkout.modal.destroy();
		// checkout.destroy();
		// checkout.breadcrumb.step4.complete();
		// checkout.breadcrumb.destroy();
		// checkout.complete.init(checkout.settings.orderType);
		// checkout.util.gtm.pushVirtualPageview('step5');

		// checkout.util.submitReport();
		// checkout.util.gtm.pushOrder();
		// checkout.util.eShopPixel.print();

		// console.log('qulatrics to load here');
		//reoad the qualtrics survey which has been hidden on load of /store/checkout - in eir.jsp (template)
		QSI.API.unload();
		QSI.isDebug = false;
		QSI.API.load();
		QSI.API.run();
		// console.log('crossed qulatrics');

		// legacy
		pushTransactionReadyEvent();
		clearLocalStorage();
		setConfirmOrderId(res.data.order.orderId);
		setConfirmMsg(true);
		setShowCardArea(false);
		window.history.replaceState(null, '', "/checkout/order-confirmation");
		setDataLayer("Checkout - Order Confirmation | eir.ie ", '/checkout/order-confirmation', null)
	};
	const clearLocalStorage = () => {
		document.cookie = "eir_current_order=; expires=Thu, 02 Jan 1988 00:00:00 UTC; path=/;";
		localStorage.removeItem('eir_checkout_state');
		localStorage.removeItem('eir_be_data');
		localStorage.removeItem('bundleOffers');
		localStorage.removeItem('prospectUuid');
		localStorage.removeItem('offerId');
		localStorage.removeItem('plan-name');
		localStorage.removeItem('handset-name');
		localStorage.removeItem('prepayHandsetId');
		localStorage.removeItem('IONOrderReference');
		localStorage.removeItem('planToggle');
		var cartEmpty = { 'cartDetails': { 'numberOfProducts': 0 } };
		PubSub.publish(Constants.eventKeys.cartSubscriberAdded, cartEmpty);
		$(".cart-quantity").hide();
	}
	const paySuccessError = (res) => {
		setDataLayer("Checkout - Error : We're sorry - there has been a system error", '/checkout/order-error')
		clearLocalStorage();
		setShowCardArea(false);
		setPaymentSuccessError(true);
		setPaymentSuccessErrorTitle("We're sorry - there has been a system error");
		setPaymentSuccessErrorText('Payment may have been taken from your card but the system has failed to complete your order. Please email eirbillpayonline@eir.ie with your details to complete your order or receive a refund.');
	};
	/*payments methods*/
	/***IFRAME payment END***/

	/*****complete order start******/
	async function completeOrderWithoutPayment() {
		try {
			window.history.replaceState(null, '', "/checkout/order-confirmation");
			setLoading(true);
			let orderId = JSON.parse(localStorage.getItem("eir_be_data")).order.id;
			let endpoint = '/store/api/checkout/complete-order/';
			var bodyFormData = new FormData();
			bodyFormData.append('orderId', orderId);
			let res = await axios({
				method: 'POST',
				url: endpoint,
				cache: false,
				dataType: 'JSON',
				data: bodyFormData,
				processData: false,
				contentType: false,
				headers: {
					'Content-Type': 'application/json',
				}
			})
			if (res.status == 200) {
				completeOrderPoll();
			} else {
				setLoading(false);
				clearLocalStorage();
				setShowCardArea(false);
				setPaymentSuccessError(true);
				setDataLayer("Checkout - Error : We're sorry - there has been a system error", '/checkout/order-error')
				setPaymentSuccessErrorTitle("We're sorry - there has been a system error");
				setPaymentSuccessErrorText('Payment may have been taken from your card but the system has failed to complete your order. Please email eirbillpayonline@eir.ie with your details to complete your order or receive a refund.');

			}
		}
		catch (err) {
			setLoading(false);
			clearLocalStorage();
			setShowCardArea(false);
			setPaymentSuccessError(true);
			setDataLayer("Checkout - Error : We're sorry - there has been a system error", '/checkout/order-error')
			setPaymentSuccessErrorTitle("We're sorry - there has been a system error");
			setPaymentSuccessErrorText('Payment may have been taken from your card but the system has failed to complete your order. Please email eirbillpayonline@eir.ie with your details to complete your order or receive a refund.');
		}
	}

	async function completeOrderPoll() {
		try {
			polCounter++;
			let orderId = JSON.parse(localStorage.getItem("eir_be_data")).order.id;
			let endpoint = '/store/api/checkout/complete-order-poll/' + orderId;
			let res = await axios({
				method: 'GET',
				url: endpoint,
				cache: false,
				dataType: 'JSON',
				processData: false,
				contentType: false,
				headers: {
					'Content-Type': 'application/json',
				}
			})
			if (res.status == 200) {
				if (res.data.completed) {
					setLoading(false);
					pushTransactionReadyEvent();
					clearLocalStorage();
					setDataLayer("Checkout - Order Confirmation | eir.ie ", '/checkout/order-confirmation', null)
					setConfirmOrderId(res.data.order.orderId);
					setConfirmMsg(true);
					setShowCardArea(false);
				} else {
					if (polCounter < 20) {
						setTimeout(completeOrderPoll, 5500);
					} else {
						setLoading(false);
						clearLocalStorage();
						setShowCardArea(false);
						setPaymentSuccessError(true);
						setDataLayer("Checkout - Error : We're sorry - there has been a system error", '/checkout/order-error')
						setPaymentSuccessErrorTitle("We're sorry - there has been a system error");
						setPaymentSuccessErrorText('Payment may have been taken from your card but the system has failed to complete your order. Please email eirbillpayonline@eir.ie with your details to complete your order or receive a refund.');
					}
				}
			} else {
				setLoading(false);
				clearLocalStorage();
				setShowCardArea(false);
				setPaymentSuccessError(true);
				setDataLayer("Checkout - Error : We're sorry - there has been a system error", '/checkout/order-error')
				setPaymentSuccessErrorTitle("We're sorry - there has been a system error");
				setPaymentSuccessErrorText('Payment may have been taken from your card but the system has failed to complete your order. Please email eirbillpayonline@eir.ie with your details to complete your order or receive a refund.');
			}
		}
		catch (err) {
			console.error(err);
			setLoading(false);
			clearLocalStorage();
			setShowCardArea(false);
			setPaymentSuccessError(true);
			setDataLayer("Checkout - Error : We're sorry - there has been a system error", '/checkout/order-error')
			setPaymentSuccessErrorTitle("We're sorry - there has been a system error");
			setPaymentSuccessErrorText('Payment may have been taken from your card but the system has failed to complete your order. Please email eirbillpayonline@eir.ie with your details to complete your order or receive a refund.');
		}
	}
	/*****complete order end******/
	useEffect(() => {
		setActiveStep(2);
		window.scrollTo(0, 0);
	}, [customerCheckoutActiveStep]);
	const setCustomerCheckoutActiveStep = function (index) {
		props.setCustomerCheckoutActiveStep(index);
	}

	const defaultTheme = createMuiTheme();
	const ColorlibConnector = withStyles({
		alternativeLabel: {
			top: (isMobileOnly) ? 22 : 16,
		},
		alternativeLabel: {
			top: 22,
			[defaultTheme.breakpoints.down(768)]: {
				top: 16,
				left: -50,
			}
		},
		active: {
			'& $line': {
				backgroundImage:
					'linear-gradient( 95deg,rgba(148,62,169,255) 0%,rgba(174,53,184,255) 50%,rgba(210,39,204,255) 100%)',
			},
		},
		completed: {
			'& $line': {
				backgroundImage:
					'linear-gradient( 95deg,rgba(148,62,169,255) 0%,rgba(174,53,184,255) 50%,rgba(210,39,204,255) 100%)',
			},
		},
		line: {
			height: '0.15rem',
			border: 0,
			backgroundColor: '#eaeaf0',
			borderRadius: 1,
			width: 96,
			margin: '0 auto',
		},
	})(StepConnector);

	const useColorlibStepIconStyles = makeStyles({
		root: {
			backgroundColor: '#ccc',
			zIndex: 1,
			color: '#fff',
			width: 40,
			height: 40,
			display: 'flex',
			borderRadius: '50%',
			justifyContent: 'center',
			alignItems: 'center',
		},
		active: {
			boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
			backgroundSize: 100,
			background: 'linear-gradient(180deg, #892BA0 0%, #470A68 100%);',
		},
		completed: {
			background: 'linear-gradient(180deg, #892BA0 0%, #470A68 100%);',
		},
		'& .stepperIcon': {
			marginTop: '-1.4rem',
			marginLeft: '.4rem',
			height: 13,
			width: 7,
		},
	});

	function ColorlibStepIcon(props) {
		const classes = useColorlibStepIconStyles();
		const { active, completed } = props;

		const icons = {
			1: <Icon><img className="stepperIcon1" src={'/.galleries/checkout/1.png'} height={25} width={25} /></Icon>,
			2: <Icon><img className="stepperIcon2" src={'/.galleries/checkout/2.png'} height={25} width={25} /></Icon>,
			3: <Icon><img className="stepperIcon3" src={'/.galleries/checkout/3.png'} height={25} width={25} /></Icon>,
		};

		return (
			<div
				className={clsx(classes.root, {
					[classes.active]: active,
					[classes.completed]: completed,
				})}
			>
				{icons[String(props.icon)]}
			</div>
		);
	}

	const [activeStep, setActiveStep] = React.useState(1);
	const steps = getSteps();
	const handleBack = () => {
		if (activeStep !== 0) {
			setActiveStep((prevActiveStep) => prevActiveStep - 1);
			setCustomerCheckoutActiveStep((prevActiveStep) => prevActiveStep - 1);
		}
	};
	function getSteps() {
		if (JSON.parse(localStorage.getItem("eir_be_data"))) {
			if (JSON.parse(localStorage.getItem("eir_be_data")).order.prequal) {//checking for general order
				if (JSON.parse(localStorage.getItem("eir_be_data")).order.prequal.customerType == "NEW") {
					if (isMobileOnly) {
						return ['Customer', 'Installation', 'Payment'];
					}
					else {
						return ['Customer Details', 'Installation Details', 'Payment Details'];
					}
				}
				else if (JSON.parse(localStorage.getItem("eir_be_data")).order.prequal.customerType == JSON.parse(localStorage.getItem("eir_be_data")).order.bundle.broadband.plan.type) {
					if (isMobileOnly) {
						return ['Customer', 'Payment'];
					}
					else {
						return ['Customer Details', 'Payment Details'];
					}
				}
				else {
					if (isMobileOnly) {
						return ['Customer', 'Installation', 'Payment'];
					}
					else {
						return ['Customer Details', 'Installation Details', 'Payment Details'];
					}
				}
			} else {//for stand alone journey as there is no prequal data
				if (isMobileOnly) {
					return ['Customer', 'Payment'];
				}
				else {
					return ['Customer Details', 'Payment Details'];
				}
			}
		}
	}
	const handleStep = (step) => () => {
		if (!orderConfirm) {
			setActiveStep(step);
			setCustomerCheckoutActiveStep(step);
		}
	};
	const showDetails = () => {
		setShowCardArea(false);
		setOrderConfirm(false);
		setBankDetailsStatus(false);
	};

	const setDataLayer = ( title, url, failure) => {
		if(failure !== null){
			dataLayer.push({
				'event': 'PaymentFailure',
				'virtualPageURL': url,
				'virtualPageTitle': title
			});
		}else{
			dataLayer.push({
				'event': 'VirtualPageview',
				'virtualPageURL': url,
				'virtualPageTitle': title
			});
		}	
	}

	return (
		<Fragment>
			<ThemeProvider theme={theme}>
				{/* Start Stepper Zone */}
				<Grid>
					<Paper elevation={3} className={classes.paper}>
						<div className={classes.root + " container"}>
							{!orderConfirm && <div onClick={handleBack} className={" float-left checkoutStep_back "}>
								Back
							</div>}
							<Grid item xs={12} id="customer_checkout_container">
								<Box display={{ xs: 'none', md: 'block' }} >
									<Stepper activeStep={activeStep} connector={<ColorlibConnector />}>
										{(steps) && steps.map((label, index) => (
											<Step key={label}>
												<StepLabel onClick={handleStep(index)} StepIconComponent={ColorlibStepIcon} >{label}</StepLabel>
											</Step>
										))}
									</Stepper>
								</Box>
								<Box display={{ xs: 'block', md: 'none' }}>
									<Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
										{(steps) && steps.map((label, index) => (
											<Step key={label} id={"step-" + index}>
												<StepLabel onClick={handleStep(index)} StepIconComponent={ColorlibStepIcon} >{label}</StepLabel>
											</Step>
										))}
									</Stepper>
								</Box>
							</Grid >
							{!orderConfirm && <div class={" float-right checkoutStep_next "}>
								Next
							</div>}
						</div >
					</Paper>
				</Grid>
				{/* END Stepper Zone */}
				{!orderConfirm &&
					<Grid>
						<Grid container className={classes.mainContainer}>
							<Grid container sm={12}>
								<Grid container sm={12} className={classes.pageTitlePaddingPayment + " pageTitlePaddingPayment"}>
									<Grid item sm={7} xs={12}>
										<h1 className={classes.paymentHeading + " paymentHeading"}>Payment Details</h1>
									</Grid>
								</Grid>
							</Grid>
							<Grid item sm={12} xs={12} className={classes.paymentContainer}>
								<EirPaymentDebitInformation setBankDetailsStatus={setBankDetailsStatus} setDebitTandCStatus={setDebitTandCStatus} debitTandCError={debitTandCError} setDebitTandCError={setDebitTandCError}></EirPaymentDebitInformation>
								<EirTermsAndConditions setEirTandCStatus={setEirTandCStatus} eirTandCError={eirTandCError} setEirTandCError={setEirTandCError}></EirTermsAndConditions>
								<div className="bottom_Buttons">
									<div
										onClick={handleBack}
										className={'float-left bottom_stepBack'}>
										Back</div>
									{bankDetailsStatus &&
										<Grid container sm={12} xs={12} className={classes.paymentContinue}>
											<Grid item sm='3' xs={12} >
												<Button className={(JSON.parse(localStorage.getItem("eir_be_data")).order.bundle.mobiles.length > 0) ? classes.paymentContinueBtn : classes.paymentConfirmBtn} onClick={handleContinue} > {(JSON.parse(localStorage.getItem("eir_be_data")).order.bundle.mobiles.length > 0) ? "Continue" : "Complete order"}</Button>
											</Grid>
										</Grid>}
								</div>

							</Grid>
						</Grid>
					</Grid>
				}
				{paymentSuccessError &&
					<Grid>
						<Grid container className={classes.confirmationMainContainer}>
							<Paper className={classes.ConfirmationPaper} variant='elevation' elevation={4}>
								<Grid container sm={12} xs={12}>
									<Grid item sm={12} xs={12} className={classes.OrderSuccess}>
										<p className={classes.OrderSuccessTxt}>{paymentSuccessErrorTitle}</p>
									</Grid>
								</Grid>
								<Grid item sm={10} xs={7} className={classes.successMessage}>
									<p className={classes.paymentFormLabelColor}>{paymentSuccessErrorText}</p>
								</Grid>
							</Paper>
						</Grid>
					</Grid>
				}
				{/*ERROR SECTION START*/}
				{retryPayment &&
					<Modal
						isOpen={true}
						toggle={true}
						className="customise-billPay-modal-outer"
						centered={true}
					>
						<ModalBody className="modal-body-center">
							<div className="container">
								<div className="col align-self-center">
									<span className="text-bold-retry"> {retryMsg} </span>
									<div className="modal-CTA-retry">
										<EirButton
											className="modal-cta2"
											color="primary"
											outline={true}
											type="button"
											text="Retry"
											title="Retry to pay"
											onClick={getHppRequest}
										/>
									</div>
								</div>
							</div>
						</ModalBody>
					</Modal>
				}
				{confirmMsg &&
					<Grid>
						<Grid container className={classes.confirmationMainContainer}>
							<Grid container sm={12} className={classes.pageTitlePaddingConfirmation}>
								<Grid item sm={12} xs={12}>
									<h1 className={classes.paymentHeading + " paymentHeading"}>Confirmation</h1>
								</Grid>
							</Grid>
							<Paper className={classes.ConfirmationPaper} variant='elevation' elevation={4}>
								<Grid container sm={6} xs={12} className={classes.confirmContainer}>
									<Grid container sm={3} xs={5} className={classes.iconContainer} >
										<Grid item sm={12} xs={12} className={classes.ellipse} >
											<img className={classes.confirmationtickIcon} src={"/opencms/export/sites/default/.galleries/checkout/Tick.png"} alt={"icon"} />
										</Grid>
									</Grid>
									<Grid item sm={9} xs={12} className={classes.OrderSuccess}>
										<p className={classes.OrderSuccessTxt}>Thank you for your order</p>
										{confirmOrderId ? <p className={classes.orderNo}>Order no. {confirmOrderId}</p> : ''}
									</Grid>
								</Grid>
								<Grid item sm={10} xs={7} className={classes.successMessage}>
									<p className={classes.paymentFormLabelColor}>Your order has successfully been placed and you will receive an email advising you of the next steps. If we require any additional information, a member of our team will be in touch. Thank you for choosing eir. If you do not receive a confirmation email, please check your spam folder.</p>
								</Grid>
							</Paper>
						</Grid>
					</Grid>
				}
				{/*ERROR SECTION END*/}
				{showCardArea &&
					<Grid container className={classes.mainContainer}>
						<Grid container sm={12} xs={12}>
							<Grid container sm={12} className={classes.pageTitlePaddingPayment + " pageTitlePaddingPayment"}>
								<Grid item sm={7} xs={12}>
									<h1 className={classes.paymentHeading + " paymentHeading"}>Payment Details</h1>
								</Grid>
							</Grid>
						</Grid>
						<Grid sm={12} xs={12} className={classes.paymentArea}>
							<Paper elevation={3} >
								{loading ?
									<Grid className={classes.loadingPadding}>
										<Loading />
									</Grid> : ''}
								<Grid className={classes.IframePanel} alignContent="center">
									<div class="Iframe-Module form-element__wrapper">
										<iframe id="targetIframe" className={classes.iframePay}
											scrolling="no"></iframe>
									</div>
								</Grid>
							</Paper>
						</Grid>
						<Grid className={classes.paymentBackButtons}>
							<div className="bottom_Buttons">
								<div
									onClick={showDetails}
									className={'float-left bottom_stepBack'}>
									Back
								</div>
							</div>
						</Grid>
					</Grid>
				}
			</ThemeProvider>
		</Fragment >
	);
}